import React from 'react';
import { HorseCard } from './HorseCard';
import { useLanguage } from '../contexts/LanguageContext';
import { horses } from '../data/horses';
import { HorseGroup } from '../types/content';
export function HorsesSection() {
  const {
    t
  } = useLanguage();
  const groups: {
    id: HorseGroup;
    title: string;
    description: string;
  }[] = [{
    id: 'calm',
    title: t.horses.calm,
    description: t.horses.calmDesc
  }, {
    id: 'advanced',
    title: t.horses.advanced,
    description: t.horses.advancedDesc
  }];
  return <section id="horses" aria-labelledby="horses-title" className="scroll-mt-16 bg-cream py-20 lg:py-28" data-id="element-198" data-mp="36wcsqw1ydsiz">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-199" data-mp="3bxijwpfyt7qe">
        <div className="max-w-2xl" data-id="element-200" data-mp="3gvk3dbhaz92e">
          <h2 id="horses-title" className="font-serif text-4xl font-bold text-bark md:text-5xl" data-id="element-201" data-mp="3guisb70aemko">
            {t.horses.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-bark/75" data-id="element-202" data-mp="1hkkh0qwlhdd3">{t.horses.intro}</p>
        </div>

        <div className="mt-14 space-y-16" data-id="element-203" data-mp="1mjnb5gb1dz6a">
          {groups.map(group => <div key={group.id} className="grid gap-8 border-t border-line pt-8 lg:grid-cols-12" data-id="element-204" data-mp="jqd8r8hryts4">
              <div className="lg:col-span-3" data-id="element-205" data-mp="ewimpyep62pv">
                <h3 className="font-serif text-2xl font-bold text-bark" data-id="element-206" data-mp="9ypivc0v9ksr">{group.title}</h3>
                <p className="mt-2 leading-relaxed text-bark/70" data-id="element-207" data-mp="5xdokt71sbe8">{group.description}</p>
              </div>
              <div className="grid gap-8 sm:grid-cols-2 lg:col-span-9 lg:grid-cols-4" data-id="element-208" data-mp="12nec6ovoklty">
                {horses.filter(h => h.group === group.id).map(horse => <HorseCard key={horse.id} horse={horse} data-id="element-209" data-mp="tmghix74tqo1" />)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}